import { PromoPopperItem } from '@sparemin/blockhead';

export const popperItems: PromoPopperItem[] = [
  {
    icon: '✍️',
    label: 'Transcript',
  },
  {
    icon: '🎨',
    label: 'Episode art',
  },
  {
    icon: '🔑',
    label: 'Keywords',
  },
  {
    icon: '📣',
    label: 'Social captions',
  },
  {
    icon: '🗣️',
    label: 'Quotes + references',
  },
];
